import type { TModule } from '@modules/core/types';

import { ADMIN_ROUTE_PATHS } from './config';
import { ROLE_MANAGEMENT_ROUTES } from './role-management';
import { USER_REGISTRY_ROUTES } from './user-registry';
import { VIEW_PERMISSIONS_ROUTES } from './view-permissions';

const adminModule: TModule = {
  id: 'admin',
  fallbackRoute: [ADMIN_ROUTE_PATHS.viewPermissions],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...VIEW_PERMISSIONS_ROUTES, ...USER_REGISTRY_ROUTES, ...ROLE_MANAGEMENT_ROUTES],
};

export { ADMIN_ROUTE_PATHS as AdminRoutePaths };

export default adminModule;
